import { createContext, useContext } from 'react';

const WebFunnelContext = createContext(false);

export const WebFunnelProvider = WebFunnelContext.Provider;

export const useIsWebFunnel = () => useContext(WebFunnelContext);
